import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const defaultSortOptions = [
  {
    id: 'created|DESC',
    value: 'Meest recent eerst',
  },
  {
    id: 'created|ASC',
    value: 'Minst recent eerst',
  },
  {
    id: 'title|ASC',
    value: 'Alfabetisch (oplopend)',
  },
  {
    id: 'title|DESC',
    value: 'Alfabetisch (aflopend)',
  },
];

export const useLocationAwareSortOptions = (options) => {
  const location = useLocation();
  const [ sortOptions, setSortOptions ] = useState(options || defaultSortOptions);

  useEffect(
    () => {
      const query = new URLSearchParams(window.location.search);
      const newSortOptions = [ ...sortOptions ];

      if (query.get('location[value]')) {
        newSortOptions.unshift({
          id: 'location_distance|ASC',
          value: 'Locatie (dichtstbijzijnde eerst)',
        });
      }

      setSortOptions(newSortOptions);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ location ]);

  return sortOptions;
};
